import { z } from "zod/v4";

/** One calendar day's new-row count for a single entity. `date` is ISO `YYYY-MM-DD`. */
export const dailyCountSchema = z.object({
	count: z.number(),
	date: z.string(),
});

/** Lifetime totals per entity (live counts, soft-deleted profiles excluded). */
export const platformTotalsSchema = z.object({
	clubs: z.number().int().nonnegative(),
	games: z.number().int().nonnegative(),
	locations: z.number().int().nonnegative(),
	matches: z.number().int().nonnegative(),
	profiles: z.number().int().nonnegative(),
});

/** Daily growth series per entity over the requested window (zero days omitted). */
export const platformSeriesSchema = z.object({
	clubs: z.array(dailyCountSchema),
	games: z.array(dailyCountSchema),
	locations: z.array(dailyCountSchema),
	matches: z.array(dailyCountSchema),
	profiles: z.array(dailyCountSchema),
});

export const platformStatsSchema = z.object({
	range_days: z.number(),
	series: platformSeriesSchema,
	totals: platformTotalsSchema,
});

export type DailyCount = z.infer<typeof dailyCountSchema>;
export type PlatformTotals = z.infer<typeof platformTotalsSchema>;
export type PlatformSeries = z.infer<typeof platformSeriesSchema>;
export type PlatformStats = z.infer<typeof platformStatsSchema>;
/** Entity keys shared by `totals` and `series` — handy for iterating in the UI. */
export type PlatformEntity = keyof PlatformSeries;
